import Button from '@mui/material/Button';

import classes from './EduStorePrices.module.css';

const EduStorePrices = () => {
  return (
    <aside className={classes.eduStorePricesContainer}>
      <figure className={classes.figureEduStore}>
        <img
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imagen_EduStore.png"
          alt=""
          className={classes.img}
        />
      </figure>
      <div className={classes.eduStorePriceInfo}>
        <p className={classes.title}>Precios EduStore</p>
        <aside className={classes.priceInfoEduStoreDescription}>
          <p className={classes.priceText}>
            <strong>$0.00 USD por curso</strong>
          </p>
          <p className={classes.priceText}>
            Publica tus cursos en la EduStore sin costo alguno.
          </p>
        </aside>
        <aside
          className={classes.priceInfoEduStoreDescription}
          style={{ borderLeft: '1px solid #d8d8d8' }}
        >
          <p className={classes.priceText}>
            <strong>$1.99 USD por inscripción</strong>
          </p>
          <p className={classes.priceText}>
            Cargo único por cada inscripción a alguno de tus cursos.
          </p>
        </aside>
        <p className={classes.complementaryPriceEduStoreText}>
          Publicar en la EduStore te permitirá exponer tus cursos a
          la red de usuarios Mayahii en todo el mundo, aumentando así
          tus ventas y tus ingresos. Solo selecciona la opción de
          publicar tu curso en la EduStore desde el panel de
          administración de tu Academia ¡y recibe directamente en tu
          banco los ingresos por las ventas de tus cursos en todo el
          mundo!
        </p>
        <p className={classes.complementaryPriceEduStoreText}>
          Desde el panel de administración de tu Academia puedes
          configurar cada curso para ofrecerlo solo en tu Academia,
          solo en la EduStore, o en ambas al mismo tiempo.
        </p>
        <Button
          className={classes.createAcademyBtn}
          component="a"
          href={`${process.env.API_URL_PAGOS}/cart/checkout/createAcademy`}
        >
          Crear mi Academia
        </Button>
      </div>
    </aside>
  );
};

export default EduStorePrices;
